/* eslint-disable no-undef */
(function () {
  'use strict'

  angular.module('MktzapApp.Factories')
    .factory('ReportsActiveLogService', reportsActiveLogService)

  reportsActiveLogService.$inject = ['$resource']

  function reportsActiveLogService ($resource) {
    return $resource('', {}, {
      getData: {
        url: apiUrl + '/reports-active/search',
        method: 'GET',
        params: {},
        isArray: false
      }
    })
  }
// eslint-disable-next-line semi
})();
